// Geef elke klant (company) een eigen, stabiele kleur.
// We gebruiken de golden-angle (137.508°) zodat opeenvolgende company-id's
// visueel goed van elkaar te onderscheiden hue's krijgen.
export function colorForCompany(companyId) {
	const id = parseInt(companyId, 10);
	if (isNaN(id)) {
		return "hsl(0, 0%, 60%)";
	}
	const hue = (id * 137.508) % 360;
	return `hsl(${hue.toFixed(1)}, 70%, 50%)`;
}

export default colorForCompany;
